import React from 'react';
import PropTypes from 'prop-types';
import { HomeOutlined } from '@ant-design/icons';

// DS
import { Col, VertTypography, VertIcon } from '@vertem-core/vertice-ds';

// STYLES
import 'Assets/styles/default/components/Orders/OrderDetails/OrderDetailsStyles.less';
import { handleAddressNumberOutput } from 'Utils/commons/address';

// ORDER ADDRESS COMPONENT
const OrderAddress = ({ shippingAddress }) => {
    /* Renders */
    return (
        <Col className='col'>
            <VertTypography.Paragraph className='address-title'>
                <VertIcon component={HomeOutlined} />
                Endereço de entrega
            </VertTypography.Paragraph>
            {/* TODO: Verificar qual campo retorna essa informacao  */}
            {/* <VertTypography.Paragraph className='address-info'>
                <span>Ana Clara Diniz</span>
            </VertTypography.Paragraph> */}
            <VertTypography.Paragraph className='address-info'>
                <span>Endereço</span>: {shippingAddress?.addressText} {' '}
                {handleAddressNumberOutput(shippingAddress?.number)}, {' '}
                {shippingAddress?.complement}
            </VertTypography.Paragraph>
            <VertTypography.Paragraph className='address-info'>
                <span>Bairro</span>: {shippingAddress?.district}, {' '}
                {shippingAddress?.city}, {shippingAddress?.state}
            </VertTypography.Paragraph>
            <VertTypography.Paragraph className='address-info'>
                <span>CEP</span>: {shippingAddress?.zipCode}
            </VertTypography.Paragraph>
            <VertTypography.Paragraph className='address-info'>
                <span>{shippingAddress?.reference}</span>
            </VertTypography.Paragraph>
        </Col>
    )
}
OrderAddress.propTypes = {
    shippingAddress: PropTypes.object.isRequired,
};

export default OrderAddress;
